import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";

import ContributorBadge, { IProps } from "../ContributorBadge";

import classes from "./classes.module.scss";

export default function ProjectLeaderBadge(props: IProps) {
	return (
		<div className={classes["root"]}>
			<Typography type="p" size="xsmall" weight="regular" className={classes["label"]}>
				{I18n.trslt(I18n.asset.component.featured_project.project_leader)}
			</Typography>

			<ContributorBadge contributor={props.contributor} />
		</div>
	);
}
